import { useRecordContext } from 'react-admin';
import StatusChip from './StatusChip';

export default function StatusField({ source = 'status', size = 'small' }) {
    const record = useRecordContext();
    if (!record) return null;
    return <StatusChip value={record[source]} size={size} />;
}
